export default "/images/8bf5cd9f4e379726e58fc5f53de3ac83.avif";